import { DropdownWithHelp } from "@components/common/dropdown-with-help";
import { shouldConfigurePlanAppsSelector } from "@store/plan-creation/plan-creation-selectors";
import {
  plansCreationStateSelector,
  setAppSettings,
} from "@store/plan-creation/plan-creation-slice";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { DropdownOption } from "@flat-ui";
import { isPlanApp, PLAN_APP_NAMES, PLAN_APPS } from "@utils/product/plan-apps";

const VIEWER_TOOLTIP =
  "Select the application that opens the 360 images. If Sphere XG is picked, all links that are pointing to HoloBuilder and the HoloBuilder WebEditor will be redirected to Sphere XG, which moves the dashboard along with them. The users can still use the legacy UI if required.";

const DASHBOARD_TOOLTIP =
  "Select the default dashboard application after users log in. Note that the dashboard is only where projects/users/groups are managed and not the WebEditor application that shows the 360 images. All links pointing to the WebEditor will open it there and won't be redirected to Sphere XG.";

const appOptions: DropdownOption[] = PLAN_APPS.map((app) => ({
  key: app,
  value: app,
  label: PLAN_APP_NAMES[app],
}));

/** Lets the user pick which applications the members of the plan land in */
export function PlanAppSettingsSection(): React.JSX.Element | null {
  const dispatch = useAppDispatch();
  const shouldConfigurePlanApps = useAppSelector(
    shouldConfigurePlanAppsSelector
  );
  const {
    appSettings: { defaultViewerApp, defaultDashboardApp },
  } = useAppSelector(plansCreationStateSelector);

  if (!shouldConfigurePlanApps) {
    return null;
  }

  return (
    <>
      <DropdownWithHelp
        label="Application to use for the Viewer"
        value={defaultViewerApp}
        options={appOptions}
        fullWidth
        onChange={({ target: { value } }) => {
          if (isPlanApp(value)) {
            dispatch(setAppSettings({ defaultViewerApp: value }));
          }
        }}
        helpTooltip={VIEWER_TOOLTIP}
      />

      {defaultViewerApp !== "sphereXg" && (
        <DropdownWithHelp
          label="Application to use for the Dashboard"
          value={defaultDashboardApp}
          options={appOptions}
          fullWidth
          onChange={({ target: { value } }) => {
            if (isPlanApp(value)) {
              dispatch(setAppSettings({ defaultDashboardApp: value }));
            }
          }}
          helpTooltip={DASHBOARD_TOOLTIP}
        />
      )}
    </>
  );
}
